import { render } from "./TransferList2.vue?vue&type=template&id=2de4cbfc"
import script from "./TransferList2.vue?vue&type=script&lang=js"
export * from "./TransferList2.vue?vue&type=script&lang=js"

import "./TransferList2.vue?vue&type=style&index=0&id=2de4cbfc&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__